"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormModelFieldSubForm = exports.FormModelMutatorSubForm = void 0;
var tslib_1 = require("tslib");
var core_api_1 = require("@ikegps/core-api");
var id_1 = require("../../id");
var util_1 = require("../../math/util");
var collection_1 = require("../collection");
var form_field_1 = require("./form.field");
var form_select_list_1 = require("./form.select.list");
var form_nested_list_1 = require("./nested.list/form.nested.list");
var TITLE_FIELD_TYPES = [
    core_api_1.IkeFieldType.TEXT,
    core_api_1.IkeFieldType.NUMBER,
    core_api_1.IkeFieldType.SELECT_LIST,
    core_api_1.IkeFieldType.NESTED_LIST
];
var SITE_TYPE_FIELD = 'Site Type';
var DROP_POLE_FIELD = 'Drop Pole';
var POLE_LOADING_FIELD = 'Loading Percentage';
var SPAN_COLORS = [
    '#03a8a0',
    '#f16623',
    '#21409a',
    '#ff0984',
    '#66d313',
    '#f44546',
    '#039c4b',
    '#04adff',
    '#e48873',
    '#fedf17'
];
var FormModelMutatorSubForm = /** @class */ (function (_super) {
    tslib_1.__extends(FormModelMutatorSubForm, _super);
    function FormModelMutatorSubForm() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    FormModelMutatorSubForm.prototype.getFieldIds = function () {
        var stateValue = this.field.stateValue;
        if (Array.isArray(stateValue.fields)) {
            return stateValue.fields.slice();
        }
        return [];
    };
    FormModelMutatorSubForm.prototype.create = function (type, fieldId, index) {
        if (fieldId == null || fieldId === '') {
            fieldId = id_1.IkeId.generate(10);
        }
        var stateId = this.field.id + ':' + fieldId;
        var fields = this.getFieldIds();
        if (fields.indexOf(fieldId) > -1 || this.state.getFieldValue(stateId) != null) {
            throw new Error("FieldId must be unique: ".concat(fieldId));
        }
        if (index == null || index < 0) {
            fields.push(fieldId);
        }
        else {
            fields.splice(index + 1, 0, fieldId);
        }
        this.state.setFieldValue(stateId, { type: type, id: fieldId, displayName: '' });
        this.state.setFieldValue(this.field.fieldId, tslib_1.__assign(tslib_1.__assign({}, this.field.stateValue), { fields: fields }));
        return this.field.getField(fieldId);
    };
    FormModelMutatorSubForm.prototype.remove = function (fieldId) {
        var fields = this.getFieldIds();
        var index = fields.indexOf(fieldId);
        if (index === -1) {
            throw new Error("Cannot remove field. \"".concat(fieldId, "\" is missing from form \"").concat(this.field.id, "\""));
        }
        fields.splice(index, 1);
        this.state.setFieldValue(this.field.fieldId, tslib_1.__assign(tslib_1.__assign({}, this.field.stateValue), { fields: fields }));
    };
    /**
     * Move a field in a direction
     *
     * @param fieldId Id of field to move
     * @param direction direction to move +1 Down, -1 Up
     * @returns Index of field after move
     */
    FormModelMutatorSubForm.prototype.move = function (fieldId, direction) {
        var fields = this.getFieldIds();
        var index = fields.indexOf(fieldId);
        if (index === -1) {
            throw new Error("Cannot move field. \"".concat(fieldId, "\" is missing from form \"").concat(this.field.id, "\""));
        }
        var nextPosition = (0, util_1.clamp)(index + direction, 0, fields.length - 1);
        fields.splice(index, 1);
        fields.splice(nextPosition, 0, fieldId);
        this.state.setFieldValue(this.field.fieldId, tslib_1.__assign(tslib_1.__assign({}, this.field.stateValue), { fields: fields }));
        return nextPosition;
    };
    FormModelMutatorSubForm.prototype.label = function (label) {
        this.state.setFieldValue(this.field.fieldId, tslib_1.__assign(tslib_1.__assign({}, this.field.stateValue), { label: label }));
    };
    /**
     * Set a subform admin only state
     *
     * This functions overrides the standard adminOnly function in order to set all children adminOnly if a subform adminOnly parameter is updated
     * @param adminOnly adminOnly parmaeter value
     */
    FormModelMutatorSubForm.prototype.adminOnly = function (adminOnly) {
        _super.prototype.adminOnly.call(this, adminOnly);
        for (var _i = 0, _a = this.field.fields; _i < _a.length; _i++) {
            var field = _a[_i];
            field.Mutator.adminOnly(adminOnly);
        }
    };
    /**
     * Set a subform collector state
     *
     * This functions overrides the standard collector function in order to set all children collector if a subform collector parameter is updated
     * @param adminOnly adminOnly parmaeter value
     */
    FormModelMutatorSubForm.prototype.collector = function (collector) {
        _super.prototype.collector.call(this, collector);
        for (var _i = 0, _a = this.field.fields; _i < _a.length; _i++) {
            var field = _a[_i];
            field.Mutator.collector(collector);
        }
    };
    return FormModelMutatorSubForm;
}(form_field_1.FormModelMutatorField));
exports.FormModelMutatorSubForm = FormModelMutatorSubForm;
var FormModelFieldSubForm = /** @class */ (function (_super) {
    tslib_1.__extends(FormModelFieldSubForm, _super);
    function FormModelFieldSubForm() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._fields = {};
        return _this;
    }
    FormModelFieldSubForm.isSubForm = function (field) {
        return field.type === core_api_1.IkeFieldType.FORM;
    };
    Object.defineProperty(FormModelFieldSubForm.prototype, "Mutator", {
        get: function () {
            if (this._SFMutator == null) {
                this._SFMutator = new FormModelMutatorSubForm(this);
            }
            return this._SFMutator;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FormModelFieldSubForm.prototype, "label", {
        get: function () {
            return this.stateValue.label || [];
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FormModelFieldSubForm.prototype, "fields", {
        get: function () {
            var _this = this;
            var stateValue = this.stateValue;
            if (stateValue.fields == null) {
                return [];
            }
            return stateValue.fields.map(function (fieldId) { return _this.getField(fieldId); });
        },
        enumerable: false,
        configurable: true
    });
    FormModelFieldSubForm.prototype.getField = function (fieldId) {
        var existing = this._fields[fieldId];
        if (existing != null) {
            return existing;
        }
        if (this.stateValue == null || this.stateValue.fields == null) {
            return null;
        }
        var fieldIndex = this.stateValue.fields.indexOf(fieldId);
        if (fieldIndex === -1) {
            return null;
        }
        var fieldState = this.getForm().state.getFieldValue(this.id + ':' + fieldId);
        if (fieldState == null) {
            throw new Error('Unable to find field: ' + this.id + ':' + fieldId);
        }
        if (fieldState.type === core_api_1.IkeFieldType.FORM) {
            existing = new FormModelFieldSubForm(this, fieldState.id);
        }
        else if (fieldState.type === core_api_1.IkeFieldType.SELECT_LIST) {
            existing = new form_select_list_1.FormModelFieldSelectList(this, fieldState.id);
        }
        else if (fieldState.type === core_api_1.IkeFieldType.NESTED_LIST) {
            existing = new form_nested_list_1.FormModelFieldNestedList(this, fieldState.id);
        }
        else {
            existing = new form_field_1.FormModelField(this, fieldState.id);
        }
        this._fields[fieldId] = existing;
        return existing;
    };
    Object.defineProperty(FormModelFieldSubForm.prototype, "titleFields", {
        get: function () {
            var _this = this;
            if (this.label == null || this.label.length === 0) {
                return [this.titleField];
            }
            return this.label.map(function (f) { return _this.getField(f); });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FormModelFieldSubForm.prototype, "titleField", {
        get: function () {
            var fields = this.fields;
            var assignedTitleFields = fields.filter(function (field) { return field.title; });
            if (assignedTitleFields.length > 0) {
                return assignedTitleFields[0];
            }
            var candidateTitleFields = fields
                .filter(function (field) { return TITLE_FIELD_TYPES.indexOf(field.type) !== -1; });
            return candidateTitleFields[0];
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FormModelFieldSubForm.prototype, "subtitleField", {
        get: function () {
            var fields = this.fields;
            var assignedTitleFields = fields.filter(function (field) { return field.subtitle; });
            if (assignedTitleFields.length > 0) {
                return assignedTitleFields[0];
            }
            return null;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FormModelFieldSubForm.prototype, "siteTypeField", {
        get: function () {
            var fields = this.fields;
            var siteTypeField = fields.filter(function (field) { return field.displayName === SITE_TYPE_FIELD; });
            if (siteTypeField.length > 0) {
                return siteTypeField[0];
            }
            return null;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FormModelFieldSubForm.prototype, "dropPoleField", {
        get: function () {
            var fields = this.fields;
            var dropPoleField = fields.filter(function (field) { return field.displayName === DROP_POLE_FIELD; });
            if (dropPoleField.length > 0) {
                return dropPoleField[0];
            }
            return null;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FormModelFieldSubForm.prototype, "poleLoadingField", {
        get: function () {
            var fields = this.fields;
            var poleLoadingField = fields.filter(function (field) { return field.displayName === POLE_LOADING_FIELD; });
            if (poleLoadingField.length > 0) {
                return poleLoadingField[0];
            }
            return null;
        },
        enumerable: false,
        configurable: true
    });
    FormModelFieldSubForm.prototype.hasField = function (fieldId) {
        return this.getField(fieldId) != null;
    };
    /** Get the index of the provided field */
    FormModelFieldSubForm.prototype.getFieldIndex = function (fieldId) {
        return this.stateValue.fields.indexOf(fieldId);
    };
    /**
     * Search for a field in all children sub forms
     */
    FormModelFieldSubForm.prototype.findField = function (fieldId) {
        var fields = this.fields;
        for (var _i = 0, fields_1 = fields; _i < fields_1.length; _i++) {
            var field = fields_1[_i];
            if (field.id === fieldId) {
                return field;
            }
            if (FormModelFieldSubForm.isSubForm(field)) {
                var output = field.findField(fieldId);
                if (output != null) {
                    return output;
                }
            }
        }
        return null;
    };
    FormModelFieldSubForm.prototype.createField = function (type, currentOptions, index) {
        if (currentOptions === void 0) { currentOptions = {}; }
        var field = this.Mutator.create(type, currentOptions.id, index);
        if (currentOptions.displayName != null) {
            field.Mutator.displayName(currentOptions.displayName);
        }
        if (currentOptions.title) {
            field.Mutator.title(currentOptions.title);
        }
        if (currentOptions.subtitle) {
            field.Mutator.subtitle(currentOptions.subtitle);
        }
        if (currentOptions.adminOnly) {
            field.Mutator.adminOnly(currentOptions.adminOnly);
        }
        if (currentOptions.required) {
            field.Mutator.required(currentOptions.required);
        }
        if (currentOptions.annotationLabelFieldId) {
            field.Mutator.annotationLabelFieldId(currentOptions.annotationLabelFieldId);
        }
        if (currentOptions.clearanceThresholdInMeters) {
            field.Mutator.clearanceThresholdInMeters(currentOptions.clearanceThresholdInMeters);
        }
        if (currentOptions.cloneable != null && currentOptions.cloneable !== core_api_1.IkeCloneable.NONE) {
            field.Mutator.cloneable(currentOptions.cloneable);
        }
        field.Mutator.providers(currentOptions.providers || []);
        if (currentOptions.collector != null) {
            field.Mutator.collector(currentOptions.collector);
        }
        return field;
    };
    /**
     * Returns if the subform instance is of span type
     * @param subform subform instance
     */
    FormModelFieldSubForm.isSpanType = function (subform) {
        return ['span', 'spans'].includes(subform.schema.displayName.toLowerCase());
    };
    /**
     * Iterates recursevly to parent subforms until it finds the root id form and
     * returns the color of the form if it's span
     * @param subform subform to get root form id
     */
    FormModelFieldSubForm.getSpanColor = function (subform) {
        var _a, _b;
        if (subform instanceof collection_1.CollectionModelFieldSubForm) {
            if (subform.parent.schema.isRoot) {
                var index = subform.parent.parent.value.indexOf(subform.parent) % 10; // get last digit
                return this.isSpanType(subform.parent) ? (_a = SPAN_COLORS[index]) !== null && _a !== void 0 ? _a : null : null;
            }
            return this.getSpanColor(subform.parent.parent);
        }
        if (subform.parent) {
            if (subform.schema.isRoot) {
                var index = subform.parent.value.indexOf(subform) % 10; // get last digit
                return this.isSpanType(subform) ? (_b = SPAN_COLORS[index]) !== null && _b !== void 0 ? _b : null : null;
            }
            return this.getSpanColor(subform.parent);
        }
        return null;
    };
    return FormModelFieldSubForm;
}(form_field_1.FormModelField));
exports.FormModelFieldSubForm = FormModelFieldSubForm;
//# sourceMappingURL=form.subform.js.map